import { createReducer } from '@reduxjs/toolkit';
import { UsageActions } from './actions';
import Constants from './constants';
import { getDefaultStartDate, getDefaultEndDate } from './utils';

const initialState = {
  usageData: [],
  timeFilter: {
    startDate: getDefaultStartDate(),
    endDate: getDefaultEndDate(),
  },
  teamsFilter: null,
  statusFilter: null,
  userFilter: '',
  isExportLoading: false,
  usageAnalyticsData: null,
  isLoading: false,
  exportRequestId: null,
  isExportRequestReady: false,
};

const ACTION_HANDLER = {
  [UsageActions.fetchUsageDataSuccess]: (state, action) => {
    state.isLoading = false;
    state.usageData = action.payload || [];
  },
  [UsageActions.fetchUsageDataFailed]: (state) => {
    state.isLoading = false;
  },
  [UsageActions.fetchUsageAnalyticsSuccess]: (state, action) => {
    state.usageAnalyticsData = action.payload;
  },
  [UsageActions.onFilterChange]: (state, action) => {
    const filterType = action.payload.filter;
    const filterValue = action.payload.value;
    if (filterType === 'teams') {
      state.teamsFilter = filterValue;
    }
    if (filterType === 'status') {
      state.statusFilter = filterValue;
    }
    if (filterType === 'user') {
      state.userFilter = filterValue;
    }
    if (filterType === 'time') {
      state.timeFilter = filterValue;
    }
  },
  [UsageActions.fetchUsageData]: (state, action) => {
    state.isLoading = true;
    if (action.payload) {
      state.timeFilter = action.payload;
    }
  },
  [UsageActions.exportUsageList]: (state) => {
    state.isExportLoading = true;
  },
  [UsageActions.exportUsageListFailed]: (state) => {
    state.isExportLoading = false;
    state.exportRequestId = null;
    state.isExportRequestReady = false;
  },
  [UsageActions.exportUsageListSucceeded]: (state) => {
    state.isExportLoading = false;
    state.exportRequestId = null;
    state.isExportRequestReady = false;
  },
  [UsageActions.exportUsageListInProgress]: (state, action) => {
    if (action.payload && action.payload.requestId !== state.exportRequestId) {
      state.exportRequestId = action.payload.requestId || null;
    }
  },
  [UsageActions.exportUsageListReady]: (state, action) => {
    if (action.payload) {
      state.isExportRequestReady = Boolean(action.payload.isReady);
    }
  },
};

export const usageReducer = createReducer(initialState, ACTION_HANDLER);

export default {
  name: Constants.MODULE_NAME,
  reducer: usageReducer,
};
